module.exports = __webpack_public_path__ + "img/img22.f4425152.jpg";